<template lang="pug">
  .button-bar.nopdf
    //- クリック連打で間違えて「保存」を押してしまわないように、「確認」ボタンがあった場所にメッセージを表示する
    app-message(v-if="$parent.$parent.isConf" type="warning")
      p この内容で申請書のPDFを作成します。
        span.has-text-danger PDFを作成した後は編集することができません。
      p よろしければ「PDF作成」ボタンを押してください。

    //- 入力画面
    .buttons(v-if="$parent.$parent.isEdit")
      button-gotoconf
      button-cancel
      button-export
      button-import
      //.btn-separator
      //button-tempsave
      //button-forward
      //-button-sendurl(v-if="isTempSaved")

    //- 確認画面
    .buttons(v-else-if="$parent.$parent.isConf")
      button-save
      button-cancel(label="入力画面に戻る")

    //- 完了画面
    .buttons(v-else-if="$parent.$parent.isComp")
      button-cancel(label="TOPに戻る")
      //button-gotoref
      //.btn-separator
      //button-pdfdl button-sendurl
</template>

<script>
import Vue from 'vue'
import AppMessage from '@/components/AppMessage'

Vue.component('button-gotoconf', {
  template: '<button class="button is-primary" type="submit">入力内容の確認</button>'
})

Vue.component('button-save', {
  template: '<button class="button is-danger" type="submit">PDF作成</button>'
})

Vue.component('button-cancel', {
  props: {
    label: {type: String, required: false, default: 'キャンセル'}
  },
  template: `
    <button class="button ___is-primary ___is-outlined" type="button" @click.prevent="$parent.clickCancel">
      <!--<b-icon icon="reply" size="is-small"></b-icon>-->
      <span>{{label}}</span>
    </button>
  `
})

Vue.component('button-export', {
  template: `<b-button type="is-success" icon-left="download" @click="$parent.$emit('downloadDataFile')" data-testid="data-download">データダウンロード</b-button>`,
})

Vue.component('button-import', {
  template: `
    <span>
      <b-button type="is-success" icon-left="upload" @click="openFileSelection">データインポート</b-button>
      <b-upload v-model="file" ref="input" @input="importData" data-testid="data-import" accept=".json"></b-upload>
    </span>
  `,
  data () {
    return {
      file: null
    }
  },
  methods: {
    importData: function () {
      if (this.file) { // IEの場合、イベントが2回発火し、2回目がnullになるので除外する
        this.$parent.$emit('importData', this.file)
      }
      // 同名ファイルを再選択できるようにする
      this.$refs.input.$el.firstElementChild.value = ''
    },
    openFileSelection: function () {
      this.$refs.input.$el.firstElementChild.click()
    }
  }
})

/**
 * parentで実装が必要なもの
 *    buttonbar(@downloadDataFile="downloadDataFile" @importData="importData")
 */
export default {
  name: 'ButtonBar',
  components: {AppMessage},
  methods: {
    clickCancel: function () {
      if (this.$parent.$parent.isEdit) {
        if (this.$route.query.target === 'p') {
          this.$router.push({name: 'partner'})
        } else {
          this.$router.push({name: 'enduser'})
        }
      } else if (this.$parent.$parent.isConf) {
        this.$parent.$parent.mode = 'edit'
      } else {
        this.$router.push({name: 'home'})
      }
    }
  }
}
</script>

<style scoped>
.button-bar:not(:last-child) {
  margin-bottom: 1.5rem;
}
.button-bar:last-child {
  margin-bottom: 0;
}
.btn-separator {
  height: 1.5rem;
  display: inline-block;
  vertical-align: middle;
  border-right: 1px solid #999;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/com/ButtonBar.vue